import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { GenericRadioDurationFilter } from '../GenericBloc/GenericRadioDurationFilter/GenericRadioDurationFilter';
import type { RadioDurationFilterValueType } from '../GenericBloc/GenericRadioDurationFilter/GenericRadioDurationType';
import { RadioDurationFilterOperation } from '../GenericBloc/GenericRadioDurationFilter/GenericRadioDurationType';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getFilterMetadata } from '../../FilterChainUtils';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/SessionDurationLabelFormatter';

export function SessionDurationFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
}: AbstractSingleFilterPillsProps<RadioDurationFilterValueType>): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.SessionDuration);
  const { label1, label2 } = getLabels(currentValue);
  return (
    <GenericRadioDurationFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      options={[
        RadioDurationFilterOperation.IS,
        RadioDurationFilterOperation.IS_LESS_THAN,
        RadioDurationFilterOperation.IS_GREATER_THAN,
        RadioDurationFilterOperation.IS_BETWEEN,
      ]}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      label1={label1}
      label2={label2}
      header="The time users spent in their sessions."
    />
  );
}
